var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4412",
    "data-name": "Group 4412",
    transform: "translate(-928 -2137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4411",
    "data-name": "Group 4411",
    transform: "translate(0 -.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(936 2146.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4367",
    "data-name": "Group 4367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    className: "cls-3",
    d: "M11.223 1.41 10.173.36a1.231 1.231 0 0 0-1.74 0L.624 8.17a.346.346 0 0 0-.094.178l-.524 2.834a.339.339 0 0 0 .4.4l2.834-.525a.346.346 0 0 0 .178-.094l7.809-7.81a1.229 1.229 0 0 0-.004-1.743zM.763 10.821l.317-1.715 1.4 1.4zm2.411-.581-1.83-1.83 6.679-6.679L9.852 3.56zm7.569-7.57-.411.411L8.5 1.251 8.914.84a.552.552 0 0 1 .78 0l1.05 1.05a.551.551 0 0 1-.001.779z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    className: "cls-3",
    d: "M222.791 154.7c-.217 0-.393.284-.393.634v11.986c0 .35.176.634.393.634s.393-.284.393-.634v-11.983c0-.35-.176-.637-.393-.637zm0 0",
    transform: "rotate(90 -416.221 1520.179)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.732371bc.svg";
export { ForwardRef as ReactComponent };